module.exports = __webpack_public_path__ + "img/icon_header_news_w.8e11d304.svg";